// transactionsModule.js
import axiosConfig from '@/lib/axiosConfig';
import { API_URL } from '@/config.js';

const transactionsModule = {
  namespaced: true,
  state: {
    transactions: [],
  },
  mutations: {
    setTransactions(state, transactions) {
      state.transactions = transactions;
    },
  },
  actions: {
    fetchTransactions({ commit }, userId) {
      return axiosConfig
        .get(API_URL, {
          params: {
            action: 'get_transactions',
            userId: userId
          }
        })
        .then(response => {
          commit('setTransactions', response.data.transactions);
          return response.data.transactions;
        })
        .catch(error => {
          console.error('Error fetching transactions:', error);
        });
    },
    refundTopup({ dispatch }, { userId, topupId }) {
      return axiosConfig
        .post(API_URL + '?action=refund_topup', {
          userId: userId,
          topupId: topupId
        })
        .then(response => {
          dispatch('fetchTransactions', userId); // Обновляем транзакции после возврата
          console.log('Пополнение возвращено:', response);
        })
        .catch(error => {
          console.error('Ошибка возврата пополнения:', error);
        });
    },
    deleteWithdrawal({ dispatch }, { userId, withdrawalId }) {
      return axiosConfig
        .post(API_URL + '?action=delete_withdrawal', {
          userId: userId,
          withdrawalId: withdrawalId
        })
        .then(response => {
          dispatch('fetchTransactions', userId); // Обновляем транзакции после удаления
          console.log('Списание удалено:', response);
        })
        .catch(error => {
          console.error('Ошибка удаления списания:', error);
        });
    },
    addManualTopup({ dispatch }, { userId, amount, chatbotName }) {
      return axiosConfig
        .post(API_URL + '?action=add_manual_topup', {
          userId: userId,
          amount: amount,
          chatbotName: chatbotName
        })
        .then(response => {
          if (response.data.success) {
            dispatch('fetchTransactions', userId); // Обновляем транзакции после пополнения
            console.log('Пополнение добавлено:', response);
            return response.data;
          } else {
            throw new Error(response.data.message || 'Unknown error');
          }
        })
        .catch(error => {
          console.error('Ошибка добавления пополнения:', error);
          throw error;
        });
    },
    deleteManualTopup({ dispatch }, { userId, topupId }) {
      return axiosConfig
        .post(API_URL + '?action=delete_manual_topup', {
          topupId: topupId
        })
        .then(response => {
          if (response.data.success) {
            dispatch('fetchTransactions', userId); // Обновляем транзакции после удаления
            console.log('Ручное пополнение удалено:', response);
            return response.data;
          } else {
            throw new Error(response.data.message || 'Unknown error');
          }
        })
        .catch(error => {
          console.error('Ошибка удаления ручного пополнения:', error);
          throw error;
        });
    },
  },
  getters: {
    getTransactions(state) {
      return state.transactions;
    }
  }
};

export default transactionsModule;
